import { render, staticRenderFns } from "./sortResults.vue?vue&type=template&id=7dbefcda&"
import script from "./sortResults.vue?vue&type=script&lang=js&"
export * from "./sortResults.vue?vue&type=script&lang=js&"
import style0 from "./sortResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sortResults.vue"
export default component.exports